import IcoAlert from '../../acets/img_icon/icoAlert.svg'
import icoConfg from '../../acets/img_icon/icoConfg.svg'
import icoMensage from '../../acets/img_icon/icoMensage.svg'
import { Link } from "react-router-dom";

export default function AdminHeader(props){
  const tenancylocal = localStorage.getItem('ClienteTenancy')
    return(
      <>
            <div className="w100 linham2 row center">
               <div className="w90 row between">
                  <h5 className="c3">{props.props}</h5>
                  <div className="w30 h5 row between cell-tamanho-metade50">
                     <div className="row w40 around cell-tamanho">
                        <img src={IcoAlert} className="pp" onClick={()=>alert('Sem notificações')}/>
                        <Link to="/admindadosempresa"><img src={icoConfg} className="pp"/></Link>
                        <img src={icoMensage} className="pp" onClick={()=>alert('Sem Mensagens')}/>
                     </div>
                     <div className="row end w50 cell-none">
                        <div className="bola b3 w14 h4 cont-circ column center ml10">U</div>
                        <label className="c3">{tenancylocal}</label>
                     </div>
                  </div>
               </div>
            </div>
            
            <div className='b10 h20 w90 cont-circ8  b30'>
               <div className="row between">
                  <h5 className="c3">Welcome Back</h5>
                  <label className="c3">{new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })}</label>
                  <label className="c3 w100">Que bom lhe ver novamente! estamos com novidades!</label>
               </div>
            </div>
        </>
    )
}